export const ERouterName = {
  PILOT_LOGIN: "login", //pilot-login
  PILOT_HOME: "home", //pilot-home
  PILOT_Switch: "about",
  PILOT_Center: "center",
  // PILOT_MEDIA : 'pilot-media',
  // PILOT_LIVESHARE : 'pilot-liveshare',
  // PILOT_BIND : 'pilot-bind'
  DEVICES: "devices", //设备管理
  LIVESTREAM: "livestream", //实时直播
  HISTORY: "history", //飞行历史
  COLORS:'colors',
  COLOR2:'color2',
  // STATISTICS: "statistics", //飞行统计
  // PERSONNEL: "personnel", //人员管理
  // AIR_ROUTE: "air-route", //航线模板
  // ELECTRONIC_FENCE: "electronic-fence", //电子围栏
  // AIRPORT: "airport", //机场管理
  // MODEL: "model", //模型管理

  DEVICE_INFO: "deviceInfo",
  INFORMATION: "information",
  MEMBER: "member",
  PERMISSION: "permission",
};

export const Zh_CNName = {
  DEVICES: "设备管理", //Equipment management
  LIVESTREAM: "实时采集", //Live broadcast
  HISTORY: "采集记录", //Flight history
  COLORS:"气体颜色",
  // STATISTICS: "飞行统计", //Flight statistics
  // PERSONNEL: "人员管理", //Personnel management
  // AIR_ROUTE: "航线模板", //Route template
  // ELECTRONIC_FENCE: "电子围栏", //Electronic fence
  // AIRPORT: "机场管理", //Airport management
  // MODEL: "模型管理", //Model management

  INFORMATION: "基本信息",
  MEMBER: "成员管理",
  PERMISSION: "权限管理",
};

export const ELocalStorageKey = {
  Username: "username",
  WorkspaceId: "workspace_id",
  Token: "x-auth-token",
  PlatformName: "platform_name",
  WorkspaceName: "workspace_name",
  WorkspaceDesc: "workspace_desc",
  Flag: "flag",
  UserId: "user_id",
  Device: "device",
  GatewayOnline: "gateway_online",
  GasData: "gas_data",
  NickName:'nickname',
  AccountName:'accountname'
};

export const EUserType = {
  Web: 1,
  Pilot: 2,
};

export const EBizCode = {
  RcOsd: "rc_osd", // 4g 经纬度
  PayloadOsd: "payload_osd", // 设备 工作状态

  GatewayOsd: "gateway_osd",
  DeviceOsd: "device_osd",
  DockOsd: "dock_osd",
  MapElementCreate: "map_element_create",
  MapElementUpdate: "map_element_update",
  MapElementDelete: "map_element_delete",
  DeviceOnline: "device_online",
  DeviceOffline: "device_offline",
  DeviceHms: "device_hms",
  FirmwareVersion: "firmware_version_update",

  // 机场任务
  FlightTaskProgress: "flighttask_progress", // 机场任务执行进度
  FlightTaskMediaProgress: "file_upload_callback", // 机场任务媒体上传进度
  FlightTaskMediaHighestPriority: "highest_priority_upload_flighttask_media", // 机场任务媒体优先级上报

  // 设备指令
  DeviceReboot: "device_reboot", // 机场重启
  DroneOpen: "drone_open", // 飞行器开机
  DroneClose: "drone_close", // 飞行器关机
  DeviceFormat: "device_format", // 机场数据格式化
  DroneFormat: "drone_format", // 飞行器数据格式化
  CoverOpen: "cover_open", // 打开舱盖
  CoverClose: "cover_close", // 关闭舱盖
  PutterOpen: "putter_open", // 推杆展开
  PutterClose: "putter_close", // 推杆闭合
  ChargeOpen: "charge_open", // 打开充电
  ChargeClose: "charge_close", // 关闭充电

  // 设备升级
  DeviceUpgrade: "ota_progress", // 设备升级

  // 设备日志
  DeviceLogUploadProgress: "fileupload_progress", // 设备日志上传

  // 飞行指令消息
  ControlSourceChange: "control_source_change", // 控制权更新
  FlyToPointProgress: "fly_to_point_progress", // 飞向目标点
  TakeoffToPointProgress: "takeoff_to_point_progress", // 一键起飞
  JoystickInvalidNotify: "joystick_invalid_notify", // 设备端退出drc模式
  DrcStatusNotify: "drc_status_notify", // 飞行控制模式状态

  // custom flight area
  FlightAreasSyncProgress: "flight_areas_sync_progress",
  FlightAreasDroneLocation: "flight_areas_drone_location",
  FlightAreasUpdate: "flight_areas_update",

  // collect_data_upload_gas
  CollectDataUploadGas: "collect_data_upload_gas",
  Debugging: "collect_data_upload_gas_calibration",

  // 网络
  NetworkDisconnect: "network_disconnected_warning",
  NetworkRecover: "network_recover_notify",
};

export const EDeviceTypeName = {
  Aircraft: 0,
  Gateway: 2,
  Dock: 3,
};

export const EStatusValue = {
  CONNECTED: "Connected",
  DISCONNECT: "Disconnect",
  LIVING: "Living",
};

// export const EHmsLevel = {
//   NOTICE,
//   CAUTION,
//   WARN,
// };

export const GasName = {
  o2: "O₂",
  co: "CO",
  h2s: "H₂S",
  pm10: "PM10",
  // work_state: "work_state",
  pm25: "PM2.5",
  temperature: "温度",
  humidity: "湿度",
  flammable_gas: "可燃气体",
};

export const GasUnit = {
  o2: "%vol",
  co: "um/m3",
  h2s: "ppm",
  pm10: "μg/m³",
  pm25: "μg/m³",
  flammable_gas: "%LEL",
  temperature: "°C",
  humidity: "%",
  // work_state: "sampling",
};

